<div rds-dialog-header>
  <h2 rds-dialog-title class="ui-heading-4-bold">{{ data.title }}</h2>
</div>
<div rds-dialog-content>
  <div class="content">
    <rds-icon
      [icon]="data.icon"
      namespace="filled"
      class="icon"
      [style.fill]="data.iconColor"
    />
    <p class="ui-body-m description">{{ data.description }}</p>
  </div>
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="false" size="m">
    {{ data.buttonClose }}
  </button>
  @if (data.navigation) {
  <button rds-primary-button size="m" (click)="navigateAndClose()">
    {{ data.buttonConfirm }}
  </button>
  }
</div>
